/** Resize handle between chat and document columns (fullscreen + document split). */
export const ASSISTANT_SPLIT_RESIZE_HANDLE_CLASS = [
  'group relative w-1 shrink-0 cursor-col-resize bg-edge',
  'transition-colors hover:bg-brand-500 data-[resize-handle-active]:bg-brand-500',
  'dark:bg-edge-strong dark:hover:bg-brand-400 dark:data-[resize-handle-active]:bg-brand-400',
].join(' ');
